<template>
    <div class="page white_bg underlineCourse">

        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg lightGreyBottomBorder"
                    style="line-height: 30px;">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 80px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;"
                                  @click="back()"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 80px">
<!--                            <i class="icon favoriteIcon size24" :class="{active : isFavorite}" @click="toggleFavorite()"></i>-->
                            <i class="icon shareIcon marginL24" style="width: 22px; height: 22px;" @click="sharePoster()"></i>
                        </div>
                    </div>
                </div>
            </header>

        </div><!-- end header container -->

        <div class="body">

            

            <div style="padding: 16px 10px;">
                
                <div class="flexLayout">
                    <div style="width: 76px; margin-right: 6px;">
                        <div class="imageArea roundBorder8 hiddenOverflow" v-if="dataItem"
                             style="width: 100%; height: 86px;">
                            <!--                                        <img class="fullSpace roundBorder8" :src="dataItem.coverImg" alt=""/>-->
<!--                            <img class="fullSpace" src="datum/file_icon_word_65x85.png" v-if="dataItem.datumType === 'WORD'"/>-->
<!--                            <img class="fullSpace" src="datum/file_icon_pdf_65x85.png" v-if="dataItem.datumType === 'PDF'"/>-->
<!--                            <img class="fullSpace" src="datum/file_icon_ppt_65x85.png" v-if="dataItem.datumType === 'PPT'"/>-->
<!--                            <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.datumType === 'IMAGE_TEXT'"/>-->
<!--                            <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.datumType === 'TEACHING_PLAN'"/>-->
<!--                            <img class="fullSpace" src="datum/file_icon_audio_65x85.png" v-if="dataItem.datumType === 'MUSIC'"/>-->
<!--                            <img class="fullSpace" src="datum/file_icon_video_65x85.png" v-if="dataItem.datumType === 'VIDEO'"/>-->
<!--                            <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.datumType === 'ZIP'"/>-->
                            <img class="fullSpace" :src="dataItem.coverImg"/>

                        </div>
                    </div>
                    <div class="flexItem">
                        <div class="titleArea maxHeightTwoLine hiddenOverflow"
                             style="padding-top: 9px; line-height: 1.3em; height: 2.6em; text-overflow: ellipsis">
                            {{dataItem ? dataItem.title : ''}}
                        </div>
                        <div class="clearfix" style="margin-top: 9px; line-height: 16px;">
                            <i class="fl icon-category icon datumVipLabelIcon marginR8" style="width: 53px; height: 16px;"
                               v-show="dataItem && dataItem.chargeMode && dataItem.isV"></i>

                            <strong class="red">￥{{dataItem ? dataItem.price : '0'}}</strong>
                            <div class="fr orange" style="line-height: 20px;">
<!--                                <i class="icon viewIcon size24 marginR8 alignM relative" style="margin-top: -3px"></i>-->
<!--                                {{dataItem ? dataItem.pv : '0'}}-->
                            </div>
                        </div>
                    </div>
                </div><!-- end .flexLayout -->

                <div class="marginT12 clearfix">
                    <i class="icon tagIcon fl size24 marginR12"></i>
                    <span class="textLabel fl marginR16" style="padding: 2px 15px;"
                          v-for="catItem in dataItem ? dataItem.datumtagList.slice(0, 3) : []" :key="dataItem.id">
                        {{catItem.title}}
                    </span>
                </div>
                <div class="font12r grey clearfix" style="margin-top: 30px;">

                    <div class="floatR">更新时间：{{ dataItem ? formatDate(dataItem.updateTime) : '' }}</div>
                </div>
            </div>

            <div class="lineBBB"></div>

            <van-tabs v-model="activeType"  sticky swipeable
                  title-inactive-color="#5B616C" title-active-color="#333"
                  line-width="24" line-height="4">

                <van-tab title="内容介绍">
                    <div class="lineBBB"></div>
                    <div class="paddingV8 paddingH8">
                        <!-- introduction content -->
                       
                        <article class="font14r article" v-html="dataItem ? dataItem.describes : ''"></article>
                         <bannerModule3Vue categoryKey="DATUM_DETAIL" version="4" style="margin-bottom:10px"/>
                        <buyNotice  v-if="dataItem" :sourceType="dataItem.notice ? 'content' : 'key'"
                            :source="dataItem.notice ? dataItem.notice : 'datum_notice'"/>
                    </div>
                </van-tab>

                <van-tab title="资源明细">
                    <div class="lineBBB"></div>
                    <div class="padding12">
                        <div>
                            <span class="font14r color333">资源明细</span>
<!--                            <span class="font12r colorADAAAA paddingL8">下载后可进行预览</span>-->
                        </div>
                        <div class="marginT16">
                            <resourceList v-if="dataItem" :id="dataItem.id" @loaded="onLoadedResource"/>
                            <div class="alignCenter" v-if="resourceCount<1">可下载资源包</div>
                        </div>

                    </div>
                </van-tab>

                <!-- 认证课程没有 -->
                <van-tab title="找相关">
                    <div class="lineBBB"></div>
                    <recommendInfoList :infoList="dataItem ? dataItem.interactionList : []"/>
                </van-tab>
                

            </van-tabs>

            <bannerModule3Vue :type="56" version="4" style="margin:10px"/>

            <!-- 看广告免费下载 -->
<!--            <div v-show="freeAd">-->
<!--                <tcPlayer ref="videoPlayer" :controlBar="adPlayer.controlBar" :image="freeAd ? freeAd.coverImg : ''" :fileID="freeAd ? freeAd.adFileId : ''"-->
<!--                    @ended="onPlayEnded"/>-->
<!--            </div>-->

            <!-- 操作栏 -->
            <div class="" style="height: 86px" v-if="dataItem">
                <div class="fixedBottom white_bg" style="height: 86px">
                    <div class="">
                        <div class="vipInfo alignCenter" style="height:30px; line-height:30px; background:#FFEED5;">
                            <span class="fl font14r bold" style="margin-left: 10px" v-if="dataItem.chargeMode==1">
                                原价￥{{dataItem.price}}
                            </span>
                            <span class="fl font14r bold" style="margin-left: 10px" v-else>限时免费下载￥0</span>
                            <div class="fr" :class="{infos:dataItem.isV==1, infosx:dataItem.isV==0}">
                                <span style="font-size:14px;font-weight:bold;color:rgba(247,110,104,1);margin-right: 5px"
                                      v-if="dataItem.isV ==1 ">会员免费￥0</span>
                                <span style="font-size:14px;font-weight:bold;color:rgba(247,110,104,1);margin-right: 5px"
                                      v-else>会员享受更多</span>
                                <router-link to="/vip/datum" class="font13r bold"
                                   style="color:rgba(247,110,104,1);opacity:0.74; text-decoration: none;">立即成为会员》</router-link>
                            </div>
                        </div>
                        <div class="downInfo alignCenter" style="height:55px; background:rgba(253,195,110,1);">
                            <button class="alignCenter downloadButton" @click="goDown()">立即下载</button>
                        </div><!-- end .downInfo -->
                    </div>
                </div>
            </div>

        </div><!-- end .body -->

        <shareDrawer ref="shareDrawer" :id="dataItem ? dataItem.id : ''" :bizType="bizTypeEnum.DATUM.code"/>
        <distributeButton orderBizType="DATUM" :id="dataItem ? dataItem.id : ''" @sharePoster="sharePoster()"/>

        <payDialog ref="payDialog" type="datumOrder" :onPaySuccess="onPaySuccess"
           agreeServiceName="师讯平台资料下载须知"
           :agreeServiceUrl="dataItem && dataItem.agreement ?
           '/help/agreement_for_biz/' + bizTypeEnum.DATUM.code + '/' + dataItem.id :
           '/help/agreement/datum_download_agreement'"
           :bizType="bizTypeEnum.DATUM.code"
           :orderBizType="orderBizTypeEnum.DATUM.code"
           @selectAddress="$refs.myAddressDrawer.show();"
        />

        <datumDownloadDrawer ref="downloadDrawer" title="资料下载" @download="$refs.payDialog.open()"/>

        <videoAdDialog ref="videoAdDialog" :image="freeAd ? freeAd.coverImg : ''" :fileID="freeAd ? freeAd.adFileId : ''"
           @ended="onPlayEnded"/>

        <myAddressDrawer ref="myAddressDrawer" @selectAddress="onSelectAddress"/>
    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// api
import courseApi    from '@/components/vodCourse/vodCourseApi';
import favoriteApi  from '@/api/favorite';
import datumApi     from '@/api/datum';
import browsingApi  from '@/api/browsing';
import bannerModule3Vue from '../ad/bannerModule3.vue';

// data
import bizTypeEnum from '@/data/bizTypeEnum';
import orderBizTypeEnum from '@/data/orderBizTypeEnum';

// platformApi
import requestManager from "@comp/platformApi/requestManager";
import timerManager from "@comp/platformApi/timerManager";
import storageManager from "@comp/platformApi/storageManager";
import consoleApi from "@comp/platformApi/consoleApi";

// modules
import {Tab, Tabs} from 'vant';
import payDialog from "@comp/drawer/generalPayDialog";
import buyNotice from '@comp/contentModule/buyNotice';
import recommendInfoList from "@comp/contentModule/recommendInfoList";
import datumDownloadDrawer from "./datumDownloadDrawer";
import distributeButton from '@/components/distribution/distributeButton';
import tcPlayer from '@comp/mutilMedia/tcPlayer';
import shareDrawer from "@comp/drawer/shareDrawer";
import videoAdDialog from "@comp/ad/videoAdDialog";
import myAddressDrawer from "@comp/shopping/myAddressDrawer";
import resourceList from "./resourceList";

// util
import consoleHelper from '@util/consoleHelper';
import appHelper from '@util/appHelper';
import moment from "moment";
import userUtil from "@comp/shixunApp/userUtil";
import objectHelper from "@util/objectHelper";
import wechatHelper from "@util/wechatHelper";
import windowHelper from "@util/windowHelper";
import browsingBizTypeEnum from "@data/browsingBizTypeEnum";
import adApi from "@comp/ad/adApi";
import payApi from "@comp/deal/payApi";

const config = {
    apiConfig: {
        get: {
            url: 'portal/datum/get',
            dataColumnMapping: {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "datumDetail",
    extends : shixunPagePart,
    components: {
        'van-tab': Tab,
        'van-tabs': Tabs,
        payDialog, buyNotice, recommendInfoList,
        datumDownloadDrawer, distributeButton,
        tcPlayer, shareDrawer, videoAdDialog,bannerModule3Vue, myAddressDrawer,
        resourceList
    },
    data() {
        return {
            title: '资料详情',
            pageKey: 'file-details',
            apiConfig: config.apiConfig,
            enableDataItem: true,
            autoLoadDataItem: true,

            bizTypeEnum : bizTypeEnum,
            orderBizTypeEnum : orderBizTypeEnum,

            activeType: 0,
            userInstance: null,
            payStatusLoop: null,

            isFavorite : false,

            learnStartTime : null,
            learnEndTime : null,

            /**
             * 广告数据
             */
            freeAd : null,

            adPlayer : {
                coverImg : '',
                currentVideoFileId : '',
                controlBar : {
                    playToggle : true,
                    progressControl : false,
                    volumePanel : false,
                    currentTimeDisplay : false,
                    durationDisplay : true,
                    timeDivider : false,
                    playbackRateMenuButton : false,
                    fullscreenToggle : true,
                    QualitySwitcherMenuButton : true,
                },
                watched : false
            },

            resourceCount : 0
        }
    },
    methods: {

        onLoading() {
            appHelper.showLoading();
        },
        formatTimeRange(startTime, endTime) {
            return moment(startTime).format('HH:mm') + '-' + moment(endTime).format('HH:mm');
        },
        formatFileSize: function (limit) {
            let size = "";
            if (limit < 0.1 * 1024) { //如果小于0.1KB转化成B
                size = limit.toFixed(2) + "B";
            } else if (limit < 0.1 * 1024 * 1024) { //如果小于0.1MB转化成KB
                size = (limit / 1024).toFixed(2) + "KB";
            } else if (limit < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
                size = (limit / (1024 * 1024)).toFixed(2) + "MB";
            } else { //其他转化成GB
                size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
            }

            let sizestr = size + "";
            let len = sizestr.indexOf("\.");
            let dec = sizestr.substr(len + 1, 2);
            if (dec == "00") { //当小数点后为00时 去掉小数部分
                return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
            }
            return sizestr;
        },
        onLoadDataItem() {

            const me = this;

            appHelper.hideLoading();

            // this.title = this.dataItem.title;
            this.coverImg = this.dataItem.coverImg;
            this.isV = this.dataItem.isV;
            appHelper.setTitle(this.dataItem.title);

            consoleHelper.log('');
            consoleHelper.log('[datum detail] 资料信息:');
            consoleHelper.log('[datum detail] -- ' + this.dataItem.title);
            consoleHelper.log('[datum detail] -- datumType: ' + this.dataItem.datumType);
            consoleHelper.log('[datum detail] -- fileUrl: ' + this.dataItem.fileUrl);
            consoleHelper.log('[datum detail] -- useNetDisk: ' + this.dataItem.useNetDisk);
            consoleHelper.log('[datum detail] -- fileSize: ' + this.formatFileSize(this.dataItem.fileSize));
            consoleHelper.log('[datum detail] -- isPay: ' + this.dataItem.isPay);
            consoleHelper.log('[datum detail] -- chargeMode: ' + this.dataItem.chargeMode);
            consoleHelper.log('[datum detail] -- price: ￥' + this.dataItem.price);
            consoleHelper.log('[datum detail] -- isV: ' + this.dataItem.isV);
            consoleHelper.log('[datum detail] -- shareFree: ' + this.dataItem.shareFree);
            this.setWechatShare();

            // check free ad (未报名 且 属于看广告免费看的优惠)
            if (!this.dataItem.isPay && this.dataItem.adFree)
            // if (1)
            {
                adApi.getFreeAd({
                    bizType : bizTypeEnum.DATUM.code,
                    bizId : this.dataItem.id,
                }, (data) => {
                    me.freeAd = data;
                    // me.$refs.videoPlayer.loadVideoByID(me.freeAd.adFileId);
                });
            }

            // check is pay, 多一重验证，详情接口可能有缓存
            datumApi.checkIsPay(this.dataItem.id, (result) => {
                this.dataItem.isPay = this.dataItem.isPay || result.data;
                consoleHelper.log('[datum detail] -- isPay: ' + this.dataItem.isPay);
            });

            appHelper.checkLogin((error, userData) => {

                if (error) {
                    return;
                }

                consoleHelper.logDebug('user base info:');
                consoleHelper.logDebug('user name: ' + userData ? userData.userName : '游客');
                if (userData) {
                    me.userInstance = userUtil.createUser(userData);

                    consoleHelper.logDebug('user has course vip: ' +
                        me.userInstance.isContentHasVipPrivilege('course_vod'))
                }

                me.setWechatShare();

                if (!userData) {    // 游客
                    return;
                }

                // check favorite status
                favoriteApi.isFavorite({
                    bizId : this.dataItem.id
                }, (status) => {
                    this.isFavorite = status;
                });

            });
        },
        setWechatShare: function () {

            if (!this.dataItem) {
                return;
            }

            let path = '/datum/detail/' + this.dataItem.id;
            this.userInstance ? path += '/promotion/' + this.userInstance.introduceCode : null;

            const wechatShareOptions = {
                title: appHelper.getTitle(),
                desc: '',
                link: appHelper.generateShareUrl(path),
                imgUrl: this.dataItem.coverImg || appHelper.getAppIcon() // 分享图标
            };
            // consoleHelper.log('');
            // consoleHelper.log('[wechat] wechatShareOptions:');
            // consoleHelper.log(wechatShareOptions);
            wechatHelper.setShare(wechatShareOptions);
        },

        goDown() {

            if (!this.userInstance) // 游客，未登录
            {
                consoleHelper.logWarn('userInstance is null, go to login.');
                appHelper.goToLoginPage();
                return;
            }

            if(!this.dataItem.chargeMode)   // 免费
            {
                if (this.dataItem.isPay)
                {
                    this.goToDownloadPage();
                }
                else {
                    if (this.dataItem.adFree && !this.adPlayer.watched)  // 未观看广告
                    {
                        this.$refs.videoAdDialog.show();
                        // appHelper.showHint('观看广告后即可免费下载');
                        return;
                    }

                    datumApi.payFreeDatum(this.dataItem.id, () => {
                        this.goToDownloadPage();
                    });
                }

            }
            // VIP 课程
            else if (this.dataItem.isV && this.userInstance.isContentHasVipPrivilege('datum'))
            {
                if (this.dataItem.isPay)
                {
                    this.goToDownloadPage();
                }
                else {
                    datumApi.payFreeDatum(this.dataItem.id, () => {
                        this.goToDownloadPage();
                    });
                }
            }
            else    // 收费
            {
                if (this.dataItem.isPay)
                {
                    this.goToDownloadPage();
                }
                else
                {
                    if (this.dataItem.adFree && !this.adPlayer.watched)  // 未观看广告
                    {
                        this.$refs.videoAdDialog.show();
                        // appHelper.showHint('观看广告后即可免费下载');
                        return;
                    }
                    this.pay();
                }
            }
        },

        goToDownloadPage () {
            appHelper.goToPage('datumDownload', {
                id : this.dataItem.id
            });
        },

        pay() {

            this.$refs.payDialog.setProduct({
                id      : this.dataItem ? this.dataItem.id : '',
                title   : this.dataItem ? this.dataItem.title : '',
                image   : this.dataItem ? this.dataItem.coverImg : '',
                price   : this.dataItem ? this.dataItem.price : '',
                bizType : bizTypeEnum.DATUM.code
            });

            // Web App 无法获取浏览器分享动作
            this.$refs.downloadDrawer.setProduct({
                id      : this.dataItem ? this.dataItem.id : '',
                title   : this.dataItem ? this.dataItem.title : '',
                image   : this.dataItem ? this.dataItem.coverImg : '',
                price   : this.dataItem ? this.dataItem.price : '',
                bizType : bizTypeEnum.DATUM.code
            });

            // Web 端无法捕获浏览器分享动作，取消分享下载功能。
            this.$refs.payDialog.open();
            // this.$refs.payDialog.open();
        },
        onPaySuccess: function (data) {

            let orderId = data.orderId;

            appHelper.showHint('购买成功');

            this.reloadDataItem();
            appHelper.reloadPage();
        },

        getPayStatus(orderId) {

            const me = this;
            let options = courseApi.getPayStatus();

            options.data = {
                id: orderId
            };

            requestManager.request(options, (error, result) => {

                if (result.errorCode !== 0) {
                    appHelper.showHint(result.msg)
                    return
                }

                if (result.data.status === 2) {
                    timerManager.clearInterval(me.payStatusLoop);
                }
            });
        },

        toggleFavorite() {

            let status = !this.isFavorite;

            if (status)
            {
                favoriteApi.addFavorite({
                    bizId : this.dataItem.id,
                    bizType : bizTypeEnum.UNDERLINE_COURSE.code
                }, () => {
                    appHelper.showHint('收藏成功，可前往【我的—收藏】查看');
                    this.isFavorite = status;
                });
            }
            else
            {
                favoriteApi.cancelFavorite({
                    bizId : this.dataItem.id
                }, () => {
                    appHelper.showHint('取消成功');
                    this.isFavorite = status;
                });
            }
        },

        sharePoster() {
            if (typeof(this.$refs.shareDrawer) === 'undefined')
            {
                this.share();
                return;
            }

            this.$refs.shareDrawer.init({
                id: this.dataItem.id
            });
        },

        submitBrowsingRecord() {

            this.learnEndTime = new Date().getTime();

            let data = {
                // bizId : this.player.currentItem.id,
                browsingBizId : this.dataItem.id,
                browsingBizType : browsingBizTypeEnum.DATUM.code,
                startTime : this.learnStartTime,
                endTime : this.learnEndTime,
            };
            browsingApi.addBrowsing(data, (result) => {

            });
        },

        onPlayEnded() {

            const me = this;
            adApi.datumAdFree(this.dataItem.id, () => {
                me.adPlayer.watched = true;
                me.$refs.videoAdDialog.hide();
                // appHelper.showHint('可以免费下载了！');
                me.goToDownloadPage();
                // me.reloadDataItem();
            });
        },

        onSelectAddress(data) {

            const me = this;
            payApi.submitCollectInfo({
                bizId : this.dataItem.id,
                bizType : bizTypeEnum.DATUM.code,
                payInfo : JSON.stringify(data)
            }, () => {
                appHelper.showHint('保存成功');
                me.$refs.payDialog.checkNeedFillInContactInformation();
            });
        },

        onLoadedResource(dataList) {
            this.resourceCount = dataList.length;
        }

    },

    mounted() {

        let promotionCode = this.$route.params.promotionCode || '';
        const me = this;

        appHelper.checkLogin((error, userData) => {

            if (error) {
                return;
            }

            consoleHelper.logDebug('user base info:');
            consoleHelper.logDebug('user name: ' + userData ? userData.userName : '游客');
            if (userData) {
                me.userInstance = userUtil.createUser(userData);

                consoleHelper.logDebug('user has course vip: ' +
                    me.userInstance.isContentHasVipPrivilege('course_vod'))
            }

            me.setWechatShare();

        }, {
            promotionCode: promotionCode
        });

        // start learn
        this.learnStartTime = new Date().getTime();
    },
    beforeDestroy() {
        this.submitBrowsingRecord();
    },
    watch: {

        $route(to, from) {

            // 同页面不同参数需要使用函数加载新数据
            if (to.name === from.name) {

                // hidden some drawer
                this.$refs.payDialog.close();

                const id = to.params.id || '';
                this.$route.params.id = id;

                this.dataItem = null;
                this.loadDataItem(id);
                windowHelper.scrollTo();
            }
            // this.$router.go(0)  // 安卓下会刷新页面，微信下会回到旧地址，苹果下无法跳转
        }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #F42418;
}
.orange {
    color: #FFB946;
}
.grey {
    color: #B3B3B3;
}
.lightGrey {
    color: #BCBCBC;
}

.lineBBB {
    height: 1px;
    background: #BBBBBB;
}

.tabModule {
    .tabHeader {
        color: #5B616C;

        .item {
            position: relative;
            padding: 18px 0;

            &.active {
                color: #333333;
            }

            &:before {
                display: block;
                content: '';
                position: absolute;
                width: 24px;
                height: 4px;
                line-height: 4px;
                left: 50%;
                margin-left: -12px;
                bottom: 0;
                background: #FF3838;
                border-radius: 2px;
            }
        }
    }
}

.courseList {
    .courseItem {
        padding: 10px 12px;
        background: #F9F9F9;
        border-radius: 4px;
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.liveTag {
    display: inline-block;
    text-align: center;
    width: 64px;
    height: 26px;
    line-height: 26px;
    border: 1px solid #3185FF;
    border-radius: 4px;
    font-size: 14px;
    color: #3185FF;
}

.playIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAADzklEQVRogdWbz2rcVhTGb8ZJ6oDdrGKyqBMtDFpcVzr/VGdCi1VCu7DJH2gSZ2ZsD06a7pJNl/amfYd2ZzBtn8De9QkaMH4A+wVaaAodZjAtNurCklHFeDIzutJVPvhWs7jnhz7pXh2dUcq8LiHiDThTiIgPAKAJAG0A+Dp2GwCa8W8hAAAi3iigFmOqBUEw6/v+54i4TkTfjGNEXAOA0PO8j5RSNdtQynGcSUSs54EaALtORHfm5uY+KB1Ma301BntuGqyPN4jojtb6ailwzHyLiFZLAMt6lZlvFck2AQB3ieilBbjELwHgrlJqwiiZ1noKER9bBMven19praeMwDHzdQBo2obqA9lYWFj4MBec67rTRNSyDTPALdd1p8eCq9fr14hopQIQ7/KK4ziTo/JNAMCjChQ/lAHgkRrlYBA/La0XPooRsT4U3Pz8/KztYsd1fMQbHE1EfGa70BxeUYP2SGamChSZy77vY1+4MAwn6ezcZ73InN7oe0BHRDG50M7Ozo/Hx8d/93q9v3Z3d38qGZKzfDVmbptcpNvt/hmldHh4+GZpael1GYAisq7S2wYAOKYXifqo0+n8vrm5+V0ZkADgnAP6vv9lGYBRFEWnp6f/7O3t/VIC4Bfn8aQCHi4XAaYi+1vBkd1QStWU53kzRSzwLsAyIut53owiIs8WYAmR9VQQBIs2AYuMbBAEi0pEHlYBMIoKiex9JSKNqgBGkdnIIuIzhYhrVQJMZCiyq0pEXlQRMIrOIttqtb4dtwYReVFpwCiKooODg19zAQKA0TOoacD9/f2xAQGgXbmHTFrdbvdto9HIE9FGpbaJtI6Ojt4sLy+/ylODiDyszEaf6OTk5F9T20QQBIvWj2ppdTqdP7a2tr43WIdn9bCdlolIZu153oy116VEJiOZNjO3lVKXkn7MPRuABUTy3Ih4L91wul02YBGRzADeLrTpVHYkM3D/bzrFjaegaMAiI5kBlL6NX5NDBb1e722ZkUzBPQ/DsP/nNJPN3+3t7R9Sjd+fiwYbePVSV/FyFT9XD2sAaIZhePlCwPheNN4ELhHQGQiXiIg+s13sqGbmT4eCS6LKzE9sFz0C3BM16uyM67rT78P9CADNsSctmPk62RnbGtaruWdltNZTRPS0AjBZPzU27VSv168h4oMKQCW+X8SYZS0+zlkdxvN9/xOVvAYVIa31TREpfTBPRB5rrW8WBpZRjZk/LqornnY8+espGyPOzHxFRFBEjI80M3NbRJCZr5QO1ke1IAhm4yn7sa8qIq4h4mJlhtIvUpX+VvAfURUar1HD4YIAAAAASUVORK5CYII=');
    background-repeat: no-repeat;
}

.signUpButton {
    display: block;
    width: 100%;
    height: 42px;
    line-height: 42px;

    border: none 0;
    border-radius: 24px;
    color: #6D4025;

    background: linear-gradient(90deg, #F8D9BA 0%, #DDAF93 100%);
    /* background: linear-gradient(166deg, #F55050 0%, #FF6363 100%); */
    text-align: center;
}

.playIcon2 {
    z-index: 1 ;
    position: absolute;
    height: 84px;
    width: 84px;
    background-image: url(data:image/png;base64,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)
}
.bigLearnButton {
    //width: 339px;
    width: 100%;
    height: 48px;
    background-image: url('data:image/png;base64,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');
    background-repeat: no-repeat;
}
.openVipButton {
    //width: 162px;
    width: 100%;
    height: 48px;
    background-image: url('data:image/png;base64,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');
    background-repeat: no-repeat;
}
.learnButton {
    //width: 162px;
    width: 100%;
    height: 48px;
    background-image: url('data:image/png;base64,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');
    background-repeat: no-repeat;
}
.tagIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADDElEQVRoQ+2Zv2tTURTHz3npUHBSELSDf4DgoKJIrIkOOhRclCYvFQQRneogFJykHdyKU3WoOBQKMXkZXPwBLtbdTTMUpNBowUJQBwVLY47fl75KrPbdH+8maSFZAnn3nvv9nO85995HmHb5h3e5fuoD9NrBvgN9BxJmQF1CIuxX6CLa/Sg19ZuePfr0bQ/NvxzhtYQaY6crAQpleQ7ZIzYihOitt04Xilf4q818nTmxAKOBHB4gquoEihlT5XU60ymIWIBCIFkIW0gIEE7vGIQ1AMrjAwm9QIADwnQJ3zAr9lOlBp19MsZ1Bwn5E8IKAOKfDf6g0blr/DOMlC/JKY/pNXplUCFuERDDLiGMASB+7RfRUCXHX9rF+hWZZKEpjeyGEFlArGqMVQ4xBxB6X8rzka2R0S/n8dsr5YobA5YAkXYBYQ5A9P3zftq7cI4bfzkQyE0Em9UEcAZhDBCuLEL34MLdTbHYbvelhN4x05ABQAsCWcigHFcM5yVr4hYE0Ty+nkL0QQDdQSYO2YhAnBp6Km0LYeWAjdC4OUkgdgRA5GjNS1GmeJmXTRK0YwAiiBVAnDaBiAXIlSWTYnpjkpGkY1FORhDduMwZM0UQYTktqSYrr9N+II8x6LoqkPPnQqs8QGkVhBIAmz4XAirinuM7F6kKqAGhBtg4uUKIOUBcVa3p/DkgGkxZnBOL/4utB9B7iDogjgOithVCH6DHEGjsB6Uc30oGEEH4Ac3iCnHDebnEBMR15SHuX+PJAaIIflkedQ1CqC5NOlYq8EdnAGGgrkBAPOp/OHkTb2MvzokZNNI/1jopL4X4cA2zJu4mhIZ4ZwCtcnLphGLvb8+jEwc2A6InptHYE4nKR+P07RhA1Nj2EIbinZZQe1bgxBScmDRywkJ8xwAiJyYAMa0FYSm+owDaEAnEdxxABWHy4rKdk053oe0WyQcy7hHNtD83fXXsKUDkxG0cm/eRsTBpy5yirMnLe88BQgFjgZxsCp3wGlR09YdHV0pIayeyHNQHsEycs2l9B5yl0jLQb0UNP0CvVmVIAAAAAElFTkSuQmCC');
}
// orange view icon
.viewIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFUElEQVRoQ+1YXWwUVRQ+Z3bvVNviQzFBfoQEDZRqiGTtbguttEg0Kqay2/TBxBC0BTUGojz44otPJib+J/4VI/qgyWZbRSLxJ9gqbe3utilB0UIMSYsQiIIm9sfO7M7xzLSN3W479+7siiHZ+7I/c853z3f+7rmDcI0vvMbthyKB/zuCxQgUI5CnB4oplKcD81YvWASoq8Gf+n2i1tLwPiSqI4QVDL4KCFL8/RJ//xUAh4GsE0LzdWO4/+e8rWeAvAlQZ80Gk+gxNnQ3o1WoGUW88DOE9PN688CQms7CUp4JULT6JtOHL7EPHs7HACD6WFj0DLYkL3rB8UTAiFU/AaC9yB4v97Jplg7BGKD1rB5JvpkrXk4EKAo+0xdq501257qRijwBfa6XTD6CO374Q0XellEmQF9uLDPHrj/COo2q4F7kCOCCDlY9RpJnVfSVCNDR0A3mJHzDgAEF0B4E61PS6LiA1Blb3gT/OrSwnkDbyT+3yDA4Eud0v1mDTUMXZLJSAhStrTA1q4tjtdENjDc9g4C79Ei8303O6AjVsOwHLLtOhqenfbXY8v0VNzlXAjM5/63UawQnhUbbMJy4LPOY/Zw6g0tNgm7O4Nsl8j0iHW/AFkgvJudKwOgIcsFiq6uniEZ1gUFsil9yjDt6a4k5UdHGh9fT7OW1zn9AZ5HgFVF6pR3v/2XK+e9waJmRgjgbsMadBL2lRxJP5kyAW2UboPauzKOIVoMIJ+0osVGbVhimfgwRKhfSI4JhXRh3z+a22Vm9lUjjSEgWWXv05qTd/bLWghGgaGC1qflPc95f5wpNdExvTmx3jCdAszPYyxGrlXi0X4QTm5kkNxwAromv+cPBWHQR/C3QqMTI0Mh8mSwCjiEdwR5A3CxzDJv9OIf3HceQWOhRJvyeXMeh28p6jiyn6V4m/baCXq8Ix+tnic/KZxFgQ/azIa8qAIJArJodytiTcdYJquixTIK7VcihEgtUmuhXG+zQ2q+Hk6/P3SOLwFRH8BwX3yoVQ4SeKsMHBydmPDnOnixV0eN8G+fUc8aQmQNyTEWPJ8DRkuZERtFnE4gFRxBxtQqgSI8twZZTzuZGLMjzDJap6GUQiN5WbvrK/1LRs7tZSSRxi2sEjM7qfUDaayqAglIbsHlweKYG+jn1nLRQWP+m0OE715spn4MhX7SPa+cNVwLT3SR0nIWkR/5VLWKiPhFJ1EmL2MnLjk1rTBKnpCmR2Ua1mTZa4+5JstvoFjbEmq4dlTZK48JKV2HL4Oh87EVPYgbew8JOi3RbDLBNROJdDvFo7UpDS3/FNVS1kA4X4U+65buH55vz9nPlgwxgL3etBQ9V91EiFjzEUdjlRoBT7rwuIJA5SixtJeRbVsYogS+L0ssHM0YJEwY5EislETvIed+2mIz7MDcQEOaI3x6j6ySb/CgQGv6DYa6Xh7mtnoc5Jy2OBG40DF+vyvhb0HHaTjcN7pI5RXofcEjYQ1pK9LOBN8tqgp/3cFocJkx/J0w67eS6wPW5XGhYZVBoU9tx54k/ZfspEZjuTNVrDUC+beFyGWhez/meIJZM7sB7T/LJLl/KBOak0yEm8YAc2pPE+5zzbW45Px81JwKzyjw2PMVzzwuFfa0CBxZrlW6u8ETAiUahXmwBfSTSdOCqvtia6xHjk1CA0vQcH14PKScN0W98vnwo/Ol2bBpwCt3r8hyB+Rs6cz1ojXwNvYOfVfHkuBwJl3Gs+AMu2i93eczq08D6wl9R1oeN3SmvRs/VKxiBQhjjBaNIwIvXCqlTjEAhvekFqxgBL14rpE4xAoX0phesfwA5niZPd9/tFgAAAABJRU5ErkJggg==');
}
.moreContentRightAngleBracketIcon {
    width: 12px;
    height: 12px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAA+klEQVRIie3UIU5DQRAG4BWVHABRiSCpJW9mwswykgO0vgdAVCLrMCT0ECQIQio4QI+CrEBS1ab9EfvyeE2QOyQk/S/wZWf+nZROqRUYP8PoEyq3MYDTEEqAMWC0hdE4BsqyKAgD+nfQDsbTGEj5sYyOAKU9TGYxkMkMSocWOkRD+xYCMs+joLuym7Z5mZ5iIG0mbQkAZSDLQwxk/F52w4DxR30gywLaq7U2k/8DwH0A45cOqH1qCkCv3c832lQ9mnAfQPntB+Av3DRWERidwXh1BDhpNSCllGC06tV0Db++qgu4n/desIbLZVWggzLdw2QJkYsQ4JTf8g2l7MxweXL8cwAAAABJRU5ErkJggg==');
}
.downloadButton {
    border:none;
    height: 100%;
    width:100%;
    background: rgba(255, 96, 22, 1.0);
    background: -webkit-linear-gradient(right, rgba(255, 96, 22, 1.0), rgba(255, 113, 4, 1.0));
    background: -moz-linear-gradient(right, rgba(255, 96, 22, 1.0), rgba(255, 113, 4, 1.0));
    background: linear-gradient(to left, rgba(255, 96, 22, 1.0), rgba(255, 113, 4, 1.0));
    display: block;

    font-size:16px;
    font-weight:bold;
    color:white;
    line-height:18px;
}
.colorADAAAA {
    color: #ADAAAA;
}
</style>
